import { Tooltip } from '@mui/material';
import { GridRow } from '@mui/x-data-grid-pro';
import PropTypes from 'prop-types';

DeactivatedTooltipRow.propTypes = {
  row: PropTypes.shape({ deactivated: PropTypes.bool }),
};

export default function DeactivatedTooltipRow(props) {
  if (!props.row?.deactivated) return <GridRow {...props} />;

  return (
    <Tooltip title="Catalog product deactivated" followCursor placement="top">
      <GridRow {...props} />
    </Tooltip>
  );
}
